import percentils from './assets/dades/percentils.json'

export function interpolate(str, vars) {
	return str.replace(/\$\{(\w+)\}/g, (_, key) => vars[key] ?? '')
}

export const formatEnter = (num) => {
	const format = new Intl.NumberFormat('ca-ES')
	return format.format(num)
}

export const formatDecimal = (num, decimals = 2) => {
	return parseFloat(num).toFixed(decimals).replaceAll('.', ',')
}

export const calculCentil = (sou) => {
	const centil = percentils.find((centil) => sou <= centil.maxim)
	return centil.centil
}

export const calculCentilComunitat = (sou, comunitat) => {
	const centil = percentils.find((centil) => sou <= centil.maxim && centil.comunitat === comunitat)
	return Math.round(centil.percent_asalariat)
}

export const souMax = percentils.find((centil) => centil.centil === 100)?.maxim

export const comunitatById = (id, lang) => comunitats.find((comunitat) => comunitat.id === id)?.nom[lang]

export const comunitats = [
	{ id: 'catalunya', nom: { ca: 'Catalunya', es: 'Catalunya' } },
	{ id: 'balears', nom: { ca: 'Illes Balears', es: 'Illes Balears' } },
	{ id: 'valencia', nom: { ca: 'País Valencià', es: 'País Valencià' } },
	{ id: 'andalusia', nom: { ca: 'Andalusia', es: 'Andalucía' } },
	{ id: 'arago', nom: { ca: 'Aragó', es: 'Aragón' } },
	{
		id: 'asturies',
		nom: { ca: 'Principat d’Astúries', es: 'Principado de Asturias' },
	},
	{ id: 'canaries', nom: { ca: 'Illes Canàries', es: 'Islas Canarias' } },
	{ id: 'cantabria', nom: { ca: 'Cantàbria', es: 'Cantabria' } },
	{
		id: 'castella-la-manxa',
		nom: { ca: 'Castella-la Manxa', es: 'Castilla-La Mancha' },
	},
	{
		id: 'castella-lleo',
		nom: { ca: 'Castella i Lleó', es: 'Castilla y León' },
	},
	{ id: 'extremadura', nom: { ca: 'Extremadura', es: 'Extremadura' } },
	{ id: 'galicia', nom: { ca: 'Galícia', es: 'Galicia' } },
	{ id: 'madrid', nom: { ca: 'Madrid', es: 'Madrid' } },
	{ id: 'murcia', nom: { ca: 'Regió de Múrcia', es: 'Región de Murcia' } },
	{ id: 'rioja', nom: { ca: 'la Rioja', es: 'La Rioja' } },
]
export const edats = [
	{ id: 'menys', text: 'Menors de 26 anys' },
	{ id: '26-35', text: 'De 26 a 35 anys' },
	{ id: '36-45', text: 'De 36 a 45 anys' },
	{ id: '46-55', text: 'De 46 a 55 anys' },
	{ id: '56-65', text: 'De 56 a 65 anys' },
	{ id: 'mes', text: 'Més de 65 anys' },
]
